<app-top-bar-wrapper [type]="DashboardType.MY_COMPETITION">
  <div dashboard class="main-container">
    <div class="tabs-container">
      <div class="tab" [ngClass]="{ 'active': activeTab() === MessagingRoutePaths.MARKETING_REPORT }"
        (click)="navigateTo(MessagingRoutePaths.MARKETING_REPORT)">
        <img [src]="'svg/my-competition-tab.svg' | assetVersion" alt="Report icon">
        <span>Marketing Report</span>
      </div>
      <div class="tab" [ngClass]="{ 'active': activeTab() === MessagingRoutePaths.CREATIVE_GALLERY}"
        (click)="navigateTo(MessagingRoutePaths.CREATIVE_GALLERY)">
        <img [src]="'svg/gallery-green.svg' | assetVersion" alt="Gallery icon">
        <span>Gallery</span>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</app-top-bar-wrapper>